import { isEditorActive } from '@sitecore-jss/sitecore-jss-react';
import React, { FC } from 'react';
import { isInternalUrl } from '../../../../../utils';
import CustomExternalAnchor from '../../../customExternalAnchor';
import RoutableSitecoreLink from '../../../routableSitecoreLink';
import { TLinkWithField } from '../../types/cta.types';
import LinkChildrenAndIcon from './linkChildrenAndIcon';
import ValidHrefAndNotEditing from './validHrefAndNotEditing';

const LinkWithField: FC<TLinkWithField> = (props) => {
  const { field, hasArrowRight, ctaClassName, onClick, target, children, type } = props;

  const hasValidHref = field.value && field.value.href;
  const isEditing = (field as unknown as { editable: any }).editable;

  // only want to apply the routing link if not editing (if editing, need to render editable link value)
  if (hasValidHref && !isEditing && isInternalUrl(field.value.href)) {
    return (
      <ValidHrefAndNotEditing field={field} type={type} hasArrowRight={hasArrowRight} ctaClassName={ctaClassName} onClick={onClick}>
        {children}
      </ValidHrefAndNotEditing>
    );
  }

  if (children || hasArrowRight) {
    // if it has children or the arrow, the sitecore link component gets duplicated on EE
    // return <HasChildrenOrIcon />;
    return (
      <LinkChildrenAndIcon
        isEditing={isEditing}
        onClick={onClick}
        field={field}
        ctaClassName={ctaClassName}
        hasArrowRight={hasArrowRight}
        type={type}
        target={target}
      >
        {children}
      </LinkChildrenAndIcon>
    );
  }
  if (!hasArrowRight) {
    // Primary CTA with no children
    return <CustomExternalAnchor className={ctaClassName} field={field} onClick={onClick} />    
   }

  return <RoutableSitecoreLink field={field} onClick={onClick} className={ctaClassName} editable={isEditorActive()} />;
};

export default LinkWithField;
